export default __webpack_public_path__ + "static/media/cover_big.eb381c55.jpg";